const VOD_LIST = 'vod_list';
export const VOD_PAGE_TYPE = {
    VOD_LIST
};
